module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--2-4255ce1dc1b4adb2d840315c7f3ca518.jpg";